<template>
  <div class="doc-content content-1200 flex-nowrap">
    <div class="tree radius-8">
      <el-tree
          v-if="currentKey !== ''"
          ref="treeRef"
          :data="treeData"
          :props="{label: 'title'}"
          :expand-on-click-node="false"
          :current-node-key="currentKey"
          node-key="id"
          default-expand-all
          @node-click="handleNodeClick"
      >
        <div class="el-tree-node__label" slot-scope="{ node, data }" :title="node.label">{{ node.label }}</div>
      </el-tree>
    </div>
    <div class="document flex1">
      <ul>
        <li v-for="(item,index) in docList" :key="index" class="flex-nowrap flex-column">
          <img class="margin-b20 radius-8" :src="item.image" alt="">
          <more-button text="下载" @handleClick="handleDownload(item)"></more-button>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import {singleDocumentsSever} from "@/common/api-config";
import MoreButton from "@/components/common/MoreButton.vue";

export default {
  components: {MoreButton},
  data() {
    return {
      treeData: [], // 菜单树数据
      treeMapping: {}, // 树节点ID与树节点的映射关系
      currentKey: '', // 当前选中的节点ID
      docList: {}, // 右侧文档列表
    }
  },
  computed: {
    getRedirectMap() {
      return this.$store.getters['documentStore/getRedirectMap'];
    },
    hasRequestMap() {
      return this.$store.getters['documentStore/getStatus'];
    },
  },
  watch: {
    "$route.params.id": {
      async handler(to, from) {
        // 第一次进入请求树数据
        if (!this.treeData.length) await this.queryMenuList()
        // 重定向到第一个树节点ID
        if (!to) {
          this.$router.replace(`/doc/${this.treeData[0].id}`)
          return;
        }
        // 判断是否需要重定向
        // if (!this.hasRequestMap) await this.$store.dispatch('documentStore/queryRedirectMap')
        // if (this.getRedirectMap[to]) {
        //   this.$router.replace(`/doc/${from}`)
        //   window.location.href = this.getRedirectMap[to]
        //   return;
        // }
        this.currentKey = Number(to)
        // if (!this.treeMapping[to]) return;
        // 获取当前节点的叶子节点
        this.docList = this.getLeafNode(this.treeMapping[to])
      },
      immediate: true
    }
  },
  methods: {
    //查询菜单树数据
    queryMenuList() {
      return new Promise((resolve, reject) => {
        singleDocumentsSever.queryPdfMenuList().then(res => {
          if (res.code == 0 && res.data && res.data.length) {
            this.treeData = res.data;
            this.treeMapping = this.transformTree(this.treeData)
            resolve()
          } else {
            reject()
          }
        });
      })
    },
    // 获取文档详情
    queryDocDetail(id) {
      return new Promise(resolve => {
        singleDocumentsSever.queryPdfDetail({id, token: localStorage.getItem('Token')}).then(res => {
          if (res.code == 0) {
            resolve(res.data.redirectUrl)
          }
        });
      })


    },
    // 点击树节点
    handleNodeClick(data) {
      this.$router.replace({
        path: '/doc/' + data.id,
      })
    },
    // 下载
    async handleDownload(item) {
      //已登录
      if (localStorage.getItem('Token')) {
        if (!this.hasRequestMap) await this.$store.dispatch('documentStore/queryRedirectMap')
        if (this.getRedirectMap[item.id]) {
          window.location.href = this.getRedirectMap[item.id]
        } else {
          const url = await this.queryDocDetail(item.id)
          window.open(url)
        }
      } else {
        this.$router.push({path: '/account/login', query: {'redirect': this.$route.fullPath}});
      }
    },
    // 将树结构转化为map
    transformTree(tree) {
      let mapping = {}
      for (let i = 0; i < tree.length; i++) {
        const item = tree[i];
        mapping[item.id] = item;
        if (item.children && item.children.length) {
          mapping = {...mapping, ...this.transformTree(item.children)};
        }
      }
      return mapping
    },
    // 获取当前节点的叶子节点
    getLeafNode(node) {
      let childrenList = []
      if (!node.children || !node.children.length) {
        childrenList.push(node)
      } else {
        for (let i = 0; i < node.children.length; i++) {
          childrenList = [...childrenList, ...this.getLeafNode(node.children[i])]
        }
      }
      return childrenList
    }
  }
}
</script>


<style scoped lang="scss">
.doc-content {
  padding: 60px 0 40px;

  .tree {
    width: 300px;
    height: 698px;
    //overflow-y: auto;
    background: #FFFFFF;
    padding: 20px 0 20px 32px;
    font-weight: 500;

    /deep/ .el-tree {
      height: 100%;
      overflow-y: auto;

      .el-tree-node {
        /*清除节点聚焦样式*/
        &:focus > .el-tree-node__content {
          background: transparent;
        }

        /*节点选中样式*/
        &.is-current {

        }

        /*节点通用样式*/
        .el-tree-node__content {
          line-height: 40px;
          height: 40px;
          font-weight: 500;
          font-size: 14px;
          color: #666666;
          position: relative;
          /*图标样式*/
          .el-tree-node__expand-icon {
            position: absolute;
            right: 0;
            padding: 0;

            &:before {
              content: "";
              display: inline-block;
              width: 20px;
              height: 20px;
              background-image: url('~@/assets/img/doc/arrow.png');
              background-size: contain;
            }

            /*展开图标*/
            &.expanded {
              transform: rotate(-180deg) !important;
              -webkit-transform: rotate(-180deg) !important;
            }

            &.is-leaf {
              display: none;
            }
          }

          /*label*/
          .el-tree-node__label {
            width: calc(100% - 24px);
            vertical-align: middle;
            white-space: nowrap;
            word-break: keep-all;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          &:hover {
            background-color: transparent;
          }
        }

        /*选中样式*/
        &.is-current > .el-tree-node__content {
          font-weight: bold;
          color: #C5A020 !important;
        }

      }

      /*一级节点*/
      & > .el-tree-node {
        margin-bottom: 20px;
        padding-right: 40px;

        &.is-current > .el-tree-node__content .el-tree-node__label {
          font-weight: bold;
          color: #C5A020 !important;
        }

        & > .el-tree-node__content .el-tree-node__label {
          font-size: 18px !important;
          color: #333333 !important;
        }

      }
    }
  }

  .document {
    min-width: 0;
    padding-left: 40px;

    ul {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 40px;

      li {
        margin-right: 40px;

        img {
          width: 260px;
          height: 368px;
        }
      }
    }

  }
}
</style>
